import { render } from "./ExpertStatisticsAnswerUnansweredCalls.vue?vue&type=template&id=12228876"
import script from "./ExpertStatisticsAnswerUnansweredCalls.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsAnswerUnansweredCalls.vue?vue&type=script&lang=js"

import "./ExpertStatisticsAnswerUnansweredCalls.vue?vue&type=style&index=0&id=12228876&lang=css"
script.render = render

export default script